import React, { useEffect } from "react";
import { RideSkeleton, RideRadioButtonGroup, RideRadioButton } from "@rimac-seguros/ride-system-components";
import { CustomSliderRange } from "@/components/molecules/CustomSliderRange";
import {
  RideGlInformationSolid,
  RideInformativePopover,
} from "@rimac-seguros/ride-system-components";

export const CreditDebtAmount = ({
  list,
  currencyOptions,
  defaultValue,
  register,
  watch,
  loading,
  onSelected,
  handleSelectCurrencyType
}) => {
  const currencyTypeValue = watch("currencyType");

  useEffect(() => {
    handleSelectCurrencyType(currencyTypeValue);
  }, [currencyTypeValue]);

  return (
    <>
      <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
        <h2 className="ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
          Elige un monto mayor o igual de la deuda a la fecha de tu crédito
          <RideInformativePopover
            glyph={<RideGlInformationSolid />}
            aria-label="Montos de cobertura"
            className="absolute ml-1"
            isNonModal
            size="medium"
            position="top-start"
            title="Revisa la deuda restante en tu último recibo"
            paragraph="Elegir un monto menor impedirá que puedas endosarlo"
          />
        </h2>
        {
          !loading && list?.length > 0 ? (
            <>
              <RideRadioButtonGroup
                label="Tipo de moneda"
                orientation="horizontal"
                className=" mb-ride-gl-spacing-2xlarge lg:mb-ride-gl-spacing-4xlarge"
              >
                {currencyOptions.map((option) => (
                  <RideRadioButton
                    key={option.value}
                    text={option.text}
                    value={option.value}
                    {...register("currencyType", { required: true })}
                  />
                ))}
              </RideRadioButtonGroup>
              <div>
                <CustomSliderRange
                  list={list}
                  defaultValue={defaultValue}
                  onSelect={onSelected}
                />
              </div>
            </>
          ) : (
            <RideSkeleton type="rectangle" height={108} width="100%" />
          )
        }
      </div>
    </>
  );
};
